"use strict";
import { Application } from "@hotwired/stimulus";
import VizController from "../src/charts/controllers/viz_controller";
import { scanForShortcodes } from "../src/charts/shortcode_scanner";
import "../src/charts/styles.css";
const application = Application.start();
application.register("charts--viz", VizController);
const runScan = () => scanForShortcodes(document);
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runScan);
} else {
  runScan();
}
